module.exports = __webpack_public_path__ + "static/img/02.91702f06.png";